module.exports = "\r\n\r\n  <div>\r\n    <button type=\"button\" class=\"menu-button\" (click)=\"createNewMap()\">New Map</button>\r\n  </div>\r\n"